import { useTranslation } from "@localization/useTranslation.ts";
import DotLegalMultiSelectWithButton from "@common/components/dotLegalSelectWithButton/DotLegalMultiSelectWithButton.tsx";
import AddEditIncidentAffectedServiceDialog from "../../../masterData/incidentAffectedService/addEditIncidentAffectedServiceDialog/AddEditIncidentAffectedServiceDialog.tsx";
import { useIncidentLogAffectedServicesField } from "./IncidentLogAffectedServicesField.hooks.ts";

export interface IncidentLogAffectedServicesFieldProps {
    affectedServiceIds: Array<string>;
    onChange: (affectedServiceIds: Array<string>) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogAffectedServicesField(props: IncidentLogAffectedServicesFieldProps) {
    const { translateString } = useTranslation();
    const {
        isLoading,
        incidentAffectedServices,
        canCreateIncidentAffectedService,
        searchValue,
        setSearchValue,
        showCreateDialog,
        openCreateDialog,
        closeCreateDialog,
        onIncidentAffectedServiceCreated,
    } = useIncidentLogAffectedServicesField(props);

    return (
        <>
            <DotLegalMultiSelectWithButton
                options={incidentAffectedServices}
                isLoading={isLoading}
                chosenOptions={props.affectedServiceIds}
                onChange={props.onChange}
                label={translateString("affectedServices")}
                toolTipText={translateString("affectedServicesTooltip")}
                noOptionsLabel={translateString("noOptions")}
                disabled={props.disabled}
                errorText={props.errorText}
                buttonLabel={translateString("createIncidentAffectedService")}
                onButtonClick={openCreateDialog}
                hasPermission={canCreateIncidentAffectedService}
                searchValue={searchValue}
                onSearchValueChange={setSearchValue}
            />
            {showCreateDialog && (
                <AddEditIncidentAffectedServiceDialog initialName={searchValue} onDialogClose={closeCreateDialog} onSaved={onIncidentAffectedServiceCreated} />
            )}
        </>
    );
}

export default IncidentLogAffectedServicesField;
